import { all, put, select } from 'redux-saga/effects';

export const getDefaultLayers = ({ accordian }) => {
  const defaultLayers = accordian.reduce((acc, { layers }) => {
    return acc.concat(layers.filter((layer) => layer.default));
  }, []);
  return defaultLayers;
};

export function* selectDefaultLayer() {
  const defaultLayers = yield select(getDefaultLayers);

  yield all(
    defaultLayers.map((defaultLayer) => put({
      type: 'ADD_LAYER',
      payload: {
        ...defaultLayer,
        checked: true,
      },
    })),
  );
  yield all(
    defaultLayers.filter(({
      timeline,
    }) => Boolean(timeline))
    .map((defaultLayer) => put({
      type: 'SELECT_TIMELINE',
      payload: defaultLayer.timeline,
    })),
  );
  yield put({
    type: 'SET_BOTTOM_PANEL',
    payload: {
      page: 'timeline',
    },
  });
}
